import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faGraduationCap,faChalkboardTeacher, faUsers, faSchool, faUniversity, faIdBadge, 
    faUserGraduate, faCalendarDay, faUserFriends, faUser, 
    faArrowRight, faChevronRight, faPencilRuler, faFilter } from '@fortawesome/free-solid-svg-icons';

function iconStyle(props)
{
    if(props.large != undefined)
        return {'fontSize': '3.2em', color:'rgb(200,200,240)'};
    if(props.pict != undefined)
        return {'fontSize': '100px', color:'rgb(240,240,240)'};    
    if(props.middle != undefined)
        return {'fontSize': '1.6em'};    
    return {'fontSize': '1.1em', marginRight:'4px',color:'rgb(128,128,128)'};
}
export function ClsIcon(props) {return(<FontAwesomeIcon icon={faUserFriends} style={iconStyle(props)}/>)}
export function CrsIcon(props) {return(<FontAwesomeIcon icon={faBook} style={iconStyle(props)}/>)}
export function TchIcon(props) {return(<FontAwesomeIcon icon={faChalkboardTeacher} style={iconStyle(props)}/>)}
export function StdIcon(props) {return(<FontAwesomeIcon icon={faUserGraduate} style={iconStyle(props)}/>)}
export function SchIcon(props) {return(<FontAwesomeIcon icon={faUniversity} style={iconStyle(props)}/>)}
export function PrgIcon(props) {return(<FontAwesomeIcon icon={faIdBadge} style={iconStyle(props)}/>)}
export function TermIcon(props) {return(<FontAwesomeIcon icon={faCalendarDay} style={iconStyle(props)}/>)}
export function RightChevronIcon(props) {return(<FontAwesomeIcon icon={faChevronRight} style={iconStyle(props)}/>)}
export function TestIcon(props) {return(<FontAwesomeIcon icon={faPencilRuler} style={iconStyle(props)}/>)}
export function CrtIcon(props) {return(<FontAwesomeIcon icon={faFilter} style={iconStyle(props)}/>)}
export function CatPanelIcon(props) {return(<i className={props.icon} style={iconStyle(props)}/>)}


export function NoPersonImageIcon(props) {return(<FontAwesomeIcon icon={faUser} style={iconStyle(props)}/>)}

export function ExclamationIcon(props) {return (<i className="pi pi-exclamation-triangle" style={iconStyle(props)}/>)}

export function IconText(props)
{
    return(
        <div className="flex align-items-center">
            <div className="mr-3">{props.icon}</div>
            <div>{props.children}</div>
        </div>
    )
}

export function setCatIcon(cat){
    if (cat.catType == 'ROOT' && (cat.parentId))
        cat.icon = "pi pi-folder";
    else if (cat.catType == 'ROOT' && !(cat.parentId))
        cat.icon = "pi pi-server";
    else if (cat.catType == 'COURSE')
        cat.icon = "pi pi-book";
    else if (cat.catType == 'TOPIC')
        cat.icon = "pi pi-file";
}
